// import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";

// const ChapterTestResults = () => {
//   return (
//     <div className="container mt-4">
//       <h3 className="text-center mb-4">Chapterwise Test Results</h3>
//       <h5 className="text-center mb-4">Chapterwise Test Results</h5>
//       <div className="table-responsive">
//         <table className="table table-striped table-hover align-middle">
//           <thead className="table-dark">
//             <tr>
//               <th scope="col">SN.</th>
//               <th scope="col">Date/Time</th>
//               <th scope="col">Chapter</th>
//               <th scope="col">Sub-Chapter</th>
//               <th scope="col">Score</th>
//               <th scope="col">Total Score</th>
//             </tr>
//           </thead>
//           <tbody>
//               <tr>
//                 <td>1</td>
//                 <td>2024-10-10</td>
//                 <td>General Awareness and Contemporary Issues</td>
//                 <td>Physical Resources of Nepal</td>
//                 <td>6</td>
//                 <td>10</td>
//               </tr>
          

//               <tr>
//                 <td>1</td>
//                 <td>2024-10-10</td>
//                 <td>General Awareness and Contemporary Issues</td>
//                 <td>Public Service Charter</td>
//                 <td>9</td>
//                 <td>10</td>
//               </tr>
          
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default ChapterTestResults;



import React, { useState, useEffect, useContext,useCallback } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import AuthContext from "../../context/AuthContext";
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

const ChapterTestResults = (props) => {
  const { authTokens, user } = useContext(AuthContext);
  const [quizResults, setQuizResults] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const location = useLocation();
  const chapterCode = location.state?.chapterCode;
  const courseCode = location.state?.courseCode;


  // Fetch quiz results from the API
  const fetchQuizResults = useCallback(async () => {
    try {
      const response = await axios.get(
        `https://nec.geoneer.com.np/api/exam/courses/${courseCode}/chapters/${chapterCode}/results/`,
        {
          headers: {
            Authorization: `Bearer ${authTokens?.access}`,
          },
        }
      );
      setQuizResults(response.data);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching quiz results:", err);
      setError("Failed to load quiz results.");
      setLoading(false);
    }
  }, [authTokens?.access ,chapterCode,courseCode]); // Dependency array ensures it's only recreated if authTokens change

  useEffect(() => {
    if (authTokens && user) {
      fetchQuizResults();
    }
  }, [authTokens, user, fetchQuizResults]);
  if (loading) {
    return <p className="text-center">Loading quiz results...</p>;
  }

  if (error) {
    return <p className="text-center text-danger">{error}</p>;
  }

  return (
    <div className="container mt-4">
      <br></br>
      <br></br>
      <h3 className="text-center mb-4">Chapterwise Test Results</h3>
      <div className="table-responsive">
        <table className="table table-striped table-hover align-middle">
          <thead className="table-dark">
            <tr>
              <th scope="col">SN.</th>
              <th scope="col">Date/Time</th>
              {/* <th scope="col">Chapter</th> */}
              {/* <th scope="col">Sub-Chapter</th> */}
              <th scope="col">Score</th>
              <th scope="col">Total Score</th>
            </tr>
          </thead>
          <tbody>
            {quizResults.length > 0 ? (
              quizResults.map((result, index) => (
                <tr key={result.id}>
                  <td>{index + 1}</td>
                  <td>{new Date(result.timestamp).toLocaleString()}</td>
                  {/* <td>{result.chapter}</td> */}
                  {/* <td>{result.subChapter}</td> */}
                  <td>{result.score}</td>
                  <td>{result.total_score}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center">
                  No quiz results found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ChapterTestResults;

